<template>
  <li>
    <MenuTitle title="現在のランク" image="/img/point.png"></MenuTitle>
    <div class="menu-rank">
      <div class="icon_area">
        <img v-if="currentUser.rank != 7" :src="'/img/rank/' + currentUser.rank + '.jpg'" class="rank_icon" @click="clickRankIcon">
        <img v-if="currentUser.rank == 7" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon" @click="clickRankIcon">
      </div>
      <div class="next-rank">
        <span v-if="currentUser.rank > 1" class="line_label">
          維持ライン：
          <span v-if="currentUser.is_block_clear">達成済み</span>
          <span v-if="!currentUser.is_block_clear">未達成</span>
        </span>
        <div class="gauge">
          <DownDelta
            v-if="currentUser.rank > 1"
            :style="`margin-left:calc(${currentUser.block_rank_percent}% - 6px)`"
          ></DownDelta>
          <div class="gauge-inner" :style="`width:${rankPercentage()}%;background-color:${currentUser.rank_color};`"></div>
        </div>
        <span>消費ポイントゲージ</span>
      </div>
    </div>
    <!-- ランク維持ボタンはとりあえずコメントアウト -->
    <!-- <div v-if="currentUser.is_rank_maintained" class="rank-maintained">
      <SquareButton
        class="square-button"
        text="ランク維持"
        @handleSquareBtnClick="clickMaintainRank"
      ></SquareButton>
    </div> -->
  </li>
</template>

<script>
import MenuTitle from '@/components/organisms/header/MenuTitle.vue';
import DownDelta from '@/components/atoms/DownDelta.vue';

export default {
  components: {
    MenuTitle,
    DownDelta,
  },

  props: {
    currentUser: {
      type: Object,
      default: () => { },
      required: true,
    },
  },

  methods: {
    rankPercentage() {
      const percent = Math.floor((this.currentUser.total_buy / this.currentUser.rank_up_count) * 100);
      if (percent > 100) {
        return 100;
      }
      return percent;
    },
    clickRankIcon() {
      window.open('https://clever-sense-0fe.notion.site/1a1f8228267c80f697caf6d1272e91c4', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-rank {
  .icon_area {
    text-align: center;
    margin-top: 5px;
    img.rank_icon {
      width: 300px;
    }
  }
  .next-rank {
    span {
      font-size: 12px;
    }
    .gauge {
      width: 100%;
      height: 18px;
      border-radius: 10px;
      background-color: #e7e7e7;
      margin-top: 10px;
      position: relative;
      .gauge-inner {
        height: 100%;
        border-radius: 10px;
        position: absolute;
        top: 0;
      }
    }
  }
  .rank_icon {
    cursor: pointer;
  }
}
</style>
